<script>
import Service from '../../services/operative-plan';

import config from '../../common/genericPanelConf';
import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';
import Calendar from 'primevue/calendar';
import GenericCustomMasterDataAutocompleteV2 from '../../components/generic/GenericCustomMasterDataAutocompleteV2.vue'
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'
import GenericDataTable from '../../components/generic/GenericDataTable.vue'
import SchedulationDialog from '../../components/operative-plan/daily-plan-validation/SchedulationDialog.vue'
import EquipmentDialog from '../../components/operative-plan/EquipmentDialog.vue'
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';

import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

export default{
    setup: () => ({ v$: useVuelidate() }),
    components: {
        TabView, TabPanel,
        GenericDataTable, SchedulationDialog, EquipmentDialog,
        Calendar, GenericCustomMasterDataAutocompleteV2, ResponsiveButton 
    },
    created(){
        this.movementConfiguration = config.getConfiguration('DailyPlanValidationMovement');
        this.equipmentConfiguration = config.getConfiguration('DailyPlanValidationEquipment');
    },
    mounted(){
        this.$store.dispatch('security/setNavbarTitle', 'dailyPlanValidation.page_title');
        this.load(true);
    },
    data(){
        return{
            movementConfiguration: {},
            equipmentConfiguration: {},
            filters: {
                dailyPlanDate:new Date(),
                plantId: CommonConstants.defaultPlantId
            },
            schedulationDialog: {
                visible: false,
                planDate: null
            },
            equipmentOperationDialog: {
                visible: false,
                record: null
            },
        }
    },
    validations(){
        return {
            filters: {
                dailyPlanDate: {required},
                plantId: {}
            }
        }
    },
    computed: {
        constants(){
            return CommonConstants;
        },
        utils(){
            return Utils;
        },
        uiPermissions(){
            return this.$store.getters['security/uiPermissions'];
        }
    },
     methods: {
        load(valid){
            this.submitted = true;
            if(valid){
                let movementFilters = {
                    dailyPlanDate: Utils.formatDateForAPI(this.filters.dailyPlanDate),
                    plantId: this.filters.plantId,
                    getMovementOperations: true,
                    getEquipmentOperation: false
                }
                this.$refs.movementOperationGrid.filterFromView(movementFilters, true);

                
                let equipmentFilters = {
                    dailyPlanDate: Utils.formatDateForAPI(this.filters.dailyPlanDate),
                    plantId: this.filters.plantId,
                    getMovementOperations: false,
                    getEquipmentOperation: true
                }
                this.$refs.equipmentOperationGrid.filterFromView(equipmentFilters, true);
            }
        },
        openSchedulation(){
            this.schedulationDialog.visible = true;
            this.schedulationDialog.planDate = Utils.formatDateForAPI(this.filters.dailyPlanDate);
            this.$refs.schedulationDialog.loadData()
            this.$refs.schedulationDialog.show()
        },
        onCellEditComplete(event){
            let newData = event.newData;

            let body = {
                id: newData.id,
                isValid: newData.isValidated
            };

            Service.dailyPlanValidate(body, response => {
                if(response.success){
                    this.load(true);
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        publishPlan(){

            let planId = null;

            let movementOperationData = this.$refs.movementOperationGrid.data;
            let equipmentOperationData = this.$refs.equipmentOperationGrid.data;
            if(movementOperationData.length > 0){
                planId = movementOperationData[0].idOperativePlan;
            }else if(equipmentOperationData.length > 0){
                planId = equipmentOperationData[0].idOperativePlan;
            }
            
            if(planId == null){
                this.$toast.add({detail: this.$t('dailyPlanValidation.planEmpty'), life:3000, severity:'error'});
            }else{

                this.$confirm.require({
                    message: this.$t('dailyPlanValidation.publishPlanMessage'),
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: this.$t('yes'),
                    rejectLabel: this.$t('no'),
                    accept: () => {
                        Service.dailyPlanPublish({}, planId, response => {
                            this.$confirm.close();
                            if(response.success){
                                this.$toast.add({detail: this.$t('dailyPlanValidation.publishPlanSuccess'), life:3000, severity:'success'});
                                this.load(true);
                            }else{
                                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                            }
                        })
                    },
                    reject: () => {
                        //callback to execute when user rejects the action
                        this.$confirm.close();
                    }
                });

                
            }
        },
        showEquipmentOperationDialog(record){
            this.$refs.equipmentOperationDialog.loadEquipmentLayout(record.idScheduledOperation, true, record.tank);
            this.$refs.equipmentOperationDialog.show();
        },
        validateAll(){
            this.$confirm.require({
                message: this.$t('dailyPlanValidation.validateAllMessage'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    
                    let items = [];
                    let movementOperationData = this.$refs.movementOperationGrid.data;
                    let equipmentOperationData = this.$refs.equipmentOperationGrid.data;
                    
                    movementOperationData.forEach(el => {
                        if(!el.isValidated){
                            items.push({
                                id: el.id,
                                isValid: true
                            })
                        }
                    });

                    equipmentOperationData.forEach(el => {
                        if(!el.isValidated){
                            items.push({
                                id: el.id,
                                isValid: true
                            })
                        }
                    })
                    
                    if(items && items.length > 0){
                        Service.dailyPlanValidateAll(items, response => {
                            if(response.success){
                                this.load(true);
                                this.$confirm.close();
                            }else{
                                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                            }
                        });
                    }else{
                        this.$confirm.close();
                    }
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        }
     }
}
</script>

<template>
    <main>
        <EquipmentDialog ref="equipmentOperationDialog" :item="equipmentOperationDialog" :refreshGrid="load"/>
        <SchedulationDialog ref="schedulationDialog" :item="schedulationDialog" :refreshGrid="load"/>
        <div class="grid">
            <div class="col-12 lg:col-2 field m-3">
                <label for="from" :class="{'p-error':v$.filters.dailyPlanDate.$invalid && submitted}">{{$t('operativePlan.dailyPlanDate')}}</label>
                <Calendar
                    :class="{'p-invalid':v$.filters.dailyPlanDate.$invalid && submitted, 'p-inputtext-sm w-full': true}"
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                    :dateFormat="constants.DATE_FORMAT_POINT"
                    :showTime="false"
                    v-model="filters.dailyPlanDate"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                <div v-if="(v$.filters.dailyPlanDate.$invalid && submitted) || v$.filters.dailyPlanDate.$pending.$response">
                    <small class="p-error" v-for="error in v$.filters.dailyPlanDate.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>
            <div class="col-12 lg:col-2 field m-3">
                <label for="plant" :class="{'p-error':v$.filters.plantId.$invalid && submitted}">{{$t('registryPlant.fk')}}</label>
                <GenericCustomMasterDataAutocompleteV2
                    field="label"
                    v-model="filters.plantId"
                    :selectFirst="true"
                    api="masterdata/registry-plant-combo"
                    :addEmpty="true"
                    :emptyValue="null"
                    :emptyLabel="$t('all')"
                        :name="'registry-plant'"
                    :format="{ label: 'description', value: 'id' }"
                    :class="{'p-invalid':v$.filters.plantId.$invalid && submitted, 'p-inputtext-sm w-full': true}" />
                <div v-if="(v$.filters.plantId.$invalid && submitted) || v$.filters.plantId.$pending.$response">
                    <small class="p-error" v-for="error in v$.filters.plantId.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>
            <div class="col-12 lg:col-7 my-6">
                <ResponsiveButton :label="$t('btn.refresh')" icon="pi pi-replay" class="p-button-sm mx-1" @click="load(!v$.$invalid)"/>
                <ResponsiveButton :label="$t('dailyPlanValidation.schedulationBtn')" icon="pi pi-stopwatch" class="p-button-sm p-button-outlined mx-1" @click="openSchedulation"/>
                <ResponsiveButton :label="$t('btn.validateAll')" icon="pi pi-check" class="p-button-sm mx-1" @click="validateAll" v-if="uiPermissions('DailyPlanValidation.edit').isEnabled" />
                <ResponsiveButton :label="$t('btn.publish')" icon="pi pi-send" class="p-button-sm mx-1" @click="publishPlan"  v-if="uiPermissions('DailyPlanValidation.edit').isEnabled" />
            </div>

            <div class="col-12" style="height: 80vh">
                <tab-view>
                     <tab-panel :header="$t('operativePlan.movements')">
                        <div style="height: 70vh">
                            <GenericDataTable :configuration="movementConfiguration" :category="'movement'" :name="'operation'" ref="movementOperationGrid" :onCellEditComplete="onCellEditComplete"/>
                        </div>
                    </tab-panel>
                    <tab-panel :header="$t('operativePlan.equipments')">
                        <div style="height: 70vh">
                            <GenericDataTable :configuration="equipmentConfiguration" :category="'equipment'" :name="'operation'" ref="equipmentOperationGrid" :onCellEditComplete="onCellEditComplete" @show-equipment-operation-dialog="showEquipmentOperationDialog"/>
                        </div>
                    </tab-panel>
                </tab-view>
            </div>
        </div>
    </main>
</template>